import React, { useState } from 'react'
import { LoadingButton } from '@mui/lab';
import { Box, Button, TextField, Tooltip, InputLabel } from '@mui/material';
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import CommonSnackbar from '../common/commonSnackBar';
import Select from "react-select";
import CutProxy from "../../utility/proxy/manager/cutProxy";
import FloProxy from "../../utility/proxy/manager/floProxy";
import ShapeProxy from "../../utility/proxy/manager/shapeProxy";
import PolProxy from "../../utility/proxy/manager/polProxy";
import ColorProxy from "../../utility/proxy/manager/colorProxy";
import ClarityProxy from "../../utility/proxy/manager/clarityProxy";
import SymProxy from "../../utility/proxy/manager/symProxy";
import { useEffect } from 'react';
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import { BackupTable } from "@mui/icons-material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import PacketEvaluationProxy from '../../utility/proxy/manager/manufacturingProxy/packetEvaluationProxy';
import Papa from 'papaparse';
import StoneTypeProxy from '../../utility/proxy/manager/stoneTypeProxy';

export default function AddEvaluation({
    handleClose,
    Show,
    loading,
    handleSave,
    handleValidation,
    sourceData
}) {
    const [size, setSize] = useState("");
    const [quality, setQuality] = useState("");
    const [shade, setShade] = useState("");
    const [cutpolsym, setCutpolsym] = useState("");
    const [price, setPrice] = useState("");
    const [discount, setDiscount] = useState("");
    const [total, setTotal] = useState("");
    const [repacode, setRepaCode] = useState("");
    const [depth, setDepth] = useState("");
    const [height, setHeight] = useState("");
    const [width, setWidth] = useState('');
    const [comment, setComment] = useState("");
    const [crownheight, setCrownHeight] = useState('');
    const [culetsize, setCuletSize] = useState('');
    const [culetcondition, setCuletCondition] = useState('');
    const [depthpercent, setDepthPercent] = useState('');
    const [girdlemin, setGirdlemin] = useState('');
    const [intensitylongtitle, setIntensityLongtitle] = useState('');
    const [laserinscription, setLaserIncription] = useState('');
    const [measurements, setMeasurements] = useState('');
    const [note, setNote] = useState('');
    const [paviliondepth, setPavilionDepth] = useState('');
    const [tablepercent, setTablePercent] = useState('');
    const [open, setOpen] = useState('');
    const [girdlecondition, setGirdleCondition] = useState('');
    const [girdlepercent, setGirdlePercent] = useState('');
    const [pavilionangle, setPavilionAngle] = useState('');
    const [crownangle, setCrownAngle] = useState('');
    const [white, setWhite] = useState('');
    const [showError, setShowError] = useState(false);
    const [shape, setShape] = useState("");
    const [shapeOptions, setShapeOptions] = useState([]);
    const [clarity, setClarity] = useState("");
    const [clarityOptions, setClarityOptions] = useState([]);
    const [flo, setFlo] = useState("");
    const [flooptions, setFloOptions] = useState([]);
    const [color, setColor] = useState("");
    const [colorOptions, setColorOptions] = useState([]);
    const [cut, setCut] = useState("");
    const [cutOptions, setCutOptions] = useState([]);
    const [pol, setPol] = useState("");
    const [polOptions, setPolOptions] = useState([]);
    const [sym, setSym] = useState("");
    const [symOptions, setSymOptions] = useState([]);
    const [stoneType, setStoneType] = useState("");
    const [stoneTypeOptions, setStoneTypeOptions] = useState([]);
    const [uploadLoader, setUploadLoader] = useState(false);
    const [alertSnackbar, setAlertSnackbar] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertVariant, setAlertVariant] = useState("");

    useEffect(() => {
        getAllShapeData();
        getFloCutData();
        getAllPolData();
        getAllColorData();
        getAllCutData();
        getAllClarityData();
        getAllSymData();
        getAllStoneTypeData();
    }, []);

    useEffect(() => {
        if (shapeOptions.length > 0 && colorOptions.length > 0 && clarityOptions.length > 0 && flooptions.length > 0 && polOptions.length > 0 && symOptions.length > 0)
            getLatestEvaluationData();
    }, [cutOptions, shapeOptions, colorOptions, clarityOptions, flooptions, polOptions, symOptions]);

    const getLatestEvaluationData = () => {
        PacketEvaluationProxy.GetLatestEvaluationData(sourceData.kapanid, sourceData.packetid,
            (response) => {
                if (response)
                    setLatestEvaluationData(response)
            }
        );
    }

    const getAllCutData = () => {
        CutProxy.GetAllCutMini(
            (response) => setAllCutData(response)
        );
    };

    const getFloCutData = () => {
        FloProxy.GetAllFloMini(
            (response) => setAllFloData(response)
        );
    };

    const getAllShapeData = () => {
        ShapeProxy.GetAllShape(
            (response) => setAllShapeData(response)
        );
    };

    const getAllPolData = () => {
        PolProxy.GetAllPolMini(
            (response) => setAllPolData(response)
        );
    };

    const getAllColorData = () => {
        ColorProxy.GetAllColorMini(
            (response) => setAllColorData(response)
        );
    };

    const getAllClarityData = () => {
        ClarityProxy.GetAllClarityMini(
            (response) => setAllClarityData(response)
        );
    };

    const getAllSymData = () => {
        SymProxy.GetAllSymMini(
            (response) => setAllSymData(response)
        );
    };

    const getAllStoneTypeData = () => {
        StoneTypeProxy.GetAllStoneTypeByDisabled(false,
            (response) => setAllStoneTypeData(response)
        );
    };

    const setLatestEvaluationData = (response) => {
        setShape(response.shape ? shapeOptions.find(option => option.value.toUpperCase() === response.shape.toUpperCase()) : shape);
        setColor(response.color ? colorOptions.find(option => option.value.toUpperCase() === response.color.toUpperCase()) : color);
        setClarity(response.clarity ? clarityOptions.find(option => option.value.toUpperCase() === response.clarity.toUpperCase()) : clarity);
        setFlo(response.flo ? flooptions.find(option => option.value.toUpperCase() === response.flo.toUpperCase()) : flo);
        setCut(response.cut ? cutOptions.find(option => option.value.toUpperCase() === response.cut.toUpperCase()) : cut);
        setPol(response.pol ? polOptions.find(option => option.value.toUpperCase() === response.pol.toUpperCase()) : pol);
        setSym(response.sym ? symOptions.find(option => option.value.toUpperCase() === response.sym.toUpperCase()) : sym);
        setStoneType(response.stoneType ? stoneTypeOptions.find(option => option.value.toUpperCase() === response.sym.toUpperCase()) : stoneType);
        setSize(response.size !== null || response.size !== "" ? response.size : size);
        setQuality(response.quality !== "" ? response.quality : quality);
        setShade(response.shade !== "" ? response.shade : shade);
        setCutpolsym(response.cutpolsym !== "" ? response.cutpolsym : cutpolsym);
        setPrice(response.price !== null && response.price !== "" ? response.price : price);
        setTotal(response.total !== null && response.total !== "" ? response.total : total);
        setDiscount(response.discount !== null && response.discount !== "" ? response.discount : discount);
        setRepaCode(response.repacode !== "" ? response.repacode : repacode);
        setDepth(response.depth !== "" ? response.depth : depth);
        setHeight(response.height !== "" ? response.height : height);
        setWidth(response.width !== "" ? response.width : width);
        setComment(response.comment !== "" ? response.comment : comment);
        setCrownHeight(response.crownheight !== "" ? response.crownheight : crownheight);
        setCuletSize(response.culetsize !== "" ? response.culetsize : culetsize);
        setCuletCondition(response.culetcondition !== "" ? response.culetcondition : culetcondition);
        setDepthPercent(response.depthpercent !== "" ? response.depthpercent : depthpercent);
        setGirdlemin(response.girdlemin !== "" ? response.girdlemin : girdlemin);
        setIntensityLongtitle(response.intensitylongtitle !== "" ? response.intensitylongtitle : intensitylongtitle);
        setLaserIncription(response.laserinscription !== "" ? response.laserinscription : laserinscription);
        setMeasurements(response.measurements !== "" ? response.measurements : measurements);
        setNote(response.note !== "" ? response.note : note);
        setPavilionDepth(response.paviliondepth !== "" ? response.paviliondepth : paviliondepth);
        setTablePercent(response.tablepercent !== "" ? response.tablepercent : tablepercent);
        setOpen(response.open !== "" ? response.open : open);
        setGirdleCondition(response.girdlecondition !== "" ? response.girdlecondition : girdlecondition);
        setGirdlePercent(response.girdlepercent !== "" ? response.girdlepercent : girdlepercent);
        setPavilionAngle(response.pavilionangle !== "" ? response.pavilionangle : pavilionangle);
        setCrownAngle(response.crownangle !== "" ? response.crownangle : crownangle);
        setWhite(response.white !== "" ? response.white : white);
    };

    const setAllCutData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.name };
            options.push(option);
            return true;
        });
        setCutOptions(options)
    };

    const setAllFloData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.name };
            options.push(option);
            return true;
        });
        setFloOptions(options)
    };

    const setAllShapeData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.name };
            options.push(option);
            return true;
        });
        setShapeOptions(options)
    };


    const setAllPolData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.name };
            options.push(option);
            return true;
        });
        setPolOptions(options)
    };

    const setAllColorData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.name };
            options.push(option);
            return true;
        });
        setColorOptions(options)
    };

    const setAllClarityData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.name };
            options.push(option);
            return true;
        });
        setClarityOptions(options)
    };

    const setAllSymData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.name };
            options.push(option);
            return true;
        });
        setSymOptions(options)
    };

    const setAllStoneTypeData = (response) => {
        let sortedResponse = response.sort((a, b) => a.id - b.id);
        let options = [];
        sortedResponse.map((data) => {
            let option = { value: data.name, label: data.fullname };
            options.push(option);
            return true;
        });
        setStoneTypeOptions(options)
        setStoneType(options.find(option => option.value === "N"))
    };

    const handleClear = () => {
        const fileInput = document.getElementById('file-input');
        fileInput.value = "";
    }

    const handleUpload = (file) => {
        const reader = new FileReader();
        setUploadLoader(true);
        let finalSize = size;
        reader.onload = () => {
            const text = reader.result;
            Papa.parse(text, {
                header: true,
                skipEmptyLines: true,
                complete: (result) => {
                    if (result.data.length <= 0) {
                        setAlertSnackbar(true);
                        setAlertMessage("No Data Found");
                        setAlertVariant("warning");
                        setUploadLoader(false);
                        return;
                    }
                    let headersFromCSV = Object.keys(result.data[0]);

                    let requiredColumns = ['shape', 'color', 'clarity', 'flo', 'cut', 'pol', 'sym', 'size', 'ppc', 'total', 'discount', 'quality', 'width', 'height', 'shade', 'repacode', 'comment', 'cutpolsym', 'depth', 'crownheight', 'crownangle', 'culetsize', 'culetcondition', 'laserinscription', 'tablepercent', 'depthpercent', 'measurements', 'open', 'girdlemin', 'girdlecondition', 'girdlepercent', 'note', 'intensitylongitude', 'paviliondepth', 'pavilionangle', 'white'];
                    if (headersFromCSV.length === requiredColumns.length) {
                        const newData = result.data;
                        if (newData[0].price) {
                            const { price, size } = newData[0];
                            let size1 = size ? parseFloat(size) : parseFloat(finalSize);
                            const total = parseFloat((Number(price) * size1).toFixed(2));
                            newData[0].total = total;
                        }
                        setLatestEvaluationData(newData[0]);
                        setUploadLoader(false);
                        setAlertSnackbar(true);
                        setAlertMessage("File loaded Successfully");
                        setAlertVariant("success");
                    } else {
                        console.error('CSV columns do not match table columns.');
                        setAlertSnackbar(true);
                        setAlertMessage("CSV columns do not match table columns.");
                        setAlertVariant("error");
                        setUploadLoader(false);
                    }
                },
                error: (error) => {
                    console.error('Error parsing CSV:', error);
                    // setAlertSnackbar(true)
                }
            });
        };
        reader.readAsText(file);
    }

    const handleReset = () => {
        setShape("");
        setColor("");
        setClarity("");
        setFlo("");
        setCut("");
        setPol("");
        setSym("");
        setSize("");
        setQuality("");
        setShade("");
        setCutpolsym("");
        setPrice("");
        setRepaCode("");
        setDepth("");
        setHeight("");
        setWidth("");
        setComment("");
        setCrownHeight("");
        setCuletSize("");
        setCuletCondition("");
        setDepthPercent("");
        setGirdlemin("");
        setIntensityLongtitle("");
        setLaserIncription("");
        setMeasurements("");
        setNote("");
        setPavilionDepth("");
        setTablePercent("");
        setOpen("");
        setGirdleCondition("");
        setGirdlePercent("");
        setPavilionAngle("");
        setCrownAngle("");
        setWhite("");
        setTotal("");
        setDiscount("");
        setStoneType("");
    };

    const saveButtonDisable = () => {
        return !(
            shape && clarity && size && price && stoneType
        );
    };

    const handleEvaluation = () => {
        let data = {
            packetid: sourceData.packetid,
            kapanid: sourceData.kapanid,
            shape: shape.value,
            color: color.value,
            clarity: clarity.value,
            flo: flo.value,
            cut: cut.value,
            pol: pol.value,
            sym: sym.value,
            stonetype: stoneType.value,
            size: parseFloat(size),
            quality,
            shade,
            cutpolsym,
            price: parseFloat(price),
            discount: discount ? parseFloat(discount) : 0.0,
            total: parseFloat(total),
            repacode,
            depth,
            height,
            width,
            comment,
            crownheight,
            culetsize,
            culetcondition,
            depthpercent,
            girdlemin,
            intensitylongtitle,
            laserinscription,
            crownangle,
            measurements,
            note,
            paviliondepth,
            tablepercent,
            open,
            girdlecondition,
            girdlepercent,
            pavilionangle,
            white,
            userid: sourceData.userid,
            departmentid: sourceData.department_id,
        }
        if (handleSave) {
            if (handleValidation) {
                if (handleValidation(data)) {
                    handleSave(data);
                } else {
                    setShowError(true);
                }
            } else {
                handleSave(data);
            }
        }
    };

    const handlePriceChange = (value) => {
        if (value && size) {
            let total = parseFloat((Number(value) * size).toFixed(2));
            setPrice(value);
            setTotal(total);
        }
        else {
            setPrice(value);
        }
    }

    const handleTotalChange = (value) => {
        if (value && size) {
            let price = parseFloat((Number(value) / size).toFixed(2));
            setPrice(price);
            setTotal(value);
        }
        else {
            setTotal(value);
        }
    }

    const handleSizeChange = (value) => {
        if (value && price) {
            let total = parseFloat((Number(price) * Number(value)).toFixed(2));
            setSize(value);
            setTotal(total);
        }
        else if (value && total) {
            let price = parseFloat((Number(total) / Number(value)).toFixed(2));
            setPrice(price);
            setSize(value);
        }
        else {
            setSize(value);
        }
    }

    return (
        <Box>
            <Modal backdrop="static" show={Show} onHide={handleClose} dialogClassName="mfgEvaluationModal" enforceFocus={false}>
                <CommonSnackbar
                    show={showError}
                    message={
                        <Box>
                            Add Evaluation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={() => setShowError(false)}
                    title="Validation Failure"
                />

                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Add Evaluation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CommonSnackbar
                        show={alertSnackbar}
                        message={alertMessage}
                        variant={alertVariant}
                        autoHide={false}
                        title={alertVariant}
                        handleClose={() => setAlertSnackbar(false)}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontSize: "large",
                            marginTop: "0.5rem",
                            marginBottom: "1.5rem",
                            width: "100%",
                        }}
                    >
                        {/* Left side: Kapan Id & Packet Id */}
                        <Box>
                            <strong>Kapan Id :</strong> {sourceData.kapanid} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <strong>Packet Id :</strong> {sourceData.packetid}
                        </Box>

                        {/* Right side: Download and Upload buttons */}
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Tooltip title="Download Sample Min PPC Upload">
                                <a
                                    href="/demo_excel/SamplePacketEvaluationUpload.csv"
                                    download="SamplePacketEvaluationUpload.csv"
                                    style={{ color: "red", marginRight: "10px", marginLeft: "10px" }}
                                >
                                    <BackupTable size={25} />
                                </a>
                            </Tooltip>

                            <Tooltip title="Upload">
                                <LoadingButton
                                    color="info"
                                    variant="outlined"
                                    size="small"
                                    sx={{ mr: "10px" }}
                                    component="label"
                                    loading={uploadLoader}
                                    loadingPosition="start"
                                    startIcon={<UploadFileIcon size="large" />}
                                >
                                    Upload
                                    <input
                                        id="file-input"
                                        hidden
                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        multiple
                                        type="file"
                                        onChange={(e) => handleUpload(e.target.files[0])}
                                        onClick={(e) => handleClear()}
                                    />
                                </LoadingButton>
                            </Tooltip>
                        </Box>
                    </Box>

                    <Box
                        height={"100%"}
                        marginBottom={"30px"}
                    >
                        <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', width: "100%", gap: "10px" }}>
                            <Box sx={{ width: "13%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Stone Type :<sup style={{ color: "red" }}>*</sup></InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={stoneType}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    placeholder="Select StoneType"
                                    name="StoneType"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={stoneTypeOptions}
                                    onChange={(selectedOption) => {
                                        setStoneType(selectedOption)
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: "12.5%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Shape :<sup style={{ color: "red" }}>*</sup></InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={shape || ""}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    name="Shape"
                                    placeholder="Select Shape"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={shapeOptions}
                                    onChange={(selectedOption) => {
                                        setShape(selectedOption)
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: "12.5%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Clarity :<sup style={{ color: "red" }}>*</sup></InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={clarity}
                                    isSearchable={true}
                                    placeholder="Select Clarity"
                                    closeMenuOnSelect={true}
                                    name="Clarity"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={clarityOptions}
                                    onChange={(selectedOption) => {
                                        setClarity(selectedOption)
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: "12.5%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Color :</InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={color}
                                    placeholder="Select Color"
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    name="Color"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={colorOptions}
                                    onChange={(selectedOption) => {
                                        setColor(selectedOption)
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: "12.5%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Flo :</InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={flo}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    name="Flo"
                                    placeholder="Select Flo"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={flooptions}
                                    onChange={(selectedOption) => {
                                        setFlo(selectedOption)
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: "12.5%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Cut :</InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={cut}
                                    placeholder="Select Cut"
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    name="Cut"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={cutOptions}
                                    onChange={(selectedOption) => {
                                        setCut(selectedOption)
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: "12.5%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Pol :</InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={pol}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    placeholder="Select Pol"
                                    name="Pol"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={polOptions}
                                    onChange={(selectedOption) => {
                                        setPol(selectedOption)
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: "12.5%" }}>
                                <InputLabel sx={{ color: "black", size: "small" }}>Sym :</InputLabel>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    value={sym}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    placeholder="Select Sym"
                                    name="Sym"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={symOptions}
                                    onChange={(selectedOption) => {
                                        setSym(selectedOption)
                                    }}
                                />
                            </Box>

                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', gap: "20px", width: "100%" }}>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            type="number"
                            label="Size (Required)"
                            placeholder="Enter Size"
                            value={size}
                            onChange={(e) => handleSizeChange(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={!size && size !== 0}
                        />

                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            type='number'
                            label="Price Per Carat (Required)"
                            placeholder="Enter Price Per Carat"
                            value={price}
                            onChange={(e) => handlePriceChange(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={!price && price !== 0}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            type='number'
                            label="Total"
                            placeholder="Enter Total"
                            value={total}
                            onChange={(e) => handleTotalChange(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            type='number'
                            label="Discount"
                            placeholder="Enter Discount"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="RepaCode"
                            placeholder="Enter RepaCode"
                            value={repacode}
                            onChange={(e) => setRepaCode(e.target.value)}
                        />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', gap: "20px", width: "100%" }}>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Comment"
                            placeholder="Enter Comment"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="CutPolSym"
                            placeholder="Enter CutPolSym"
                            value={cutpolsym}
                            onChange={(e) => setCutpolsym(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Depth"
                            placeholder="Enter Depth"
                            value={depth}
                            onChange={(e) => setDepth(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Crown Height"
                            placeholder="Enter Crown Height"
                            value={crownheight}
                            onChange={(e) => setCrownHeight(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Crown Angle"
                            placeholder="Enter Crown Angle"
                            value={crownangle}
                            onChange={(e) => setCrownAngle(e.target.value)}
                        />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', gap: "20px", width: "100%" }}>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Width"
                            placeholder="Enter Width"
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Shade"
                            placeholder="Enter Shade"
                            value={shade}
                            onChange={(e) => setShade(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Height"
                            placeholder="Enter Height"
                            value={height}
                            onChange={(e) => setHeight(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Culet Size"
                            placeholder="Enter Culet Size"
                            value={culetsize}
                            onChange={(e) => setCuletSize(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Quality"
                            placeholder="Enter Quality"
                            value={quality}
                            onChange={(e) => setQuality(e.target.value)}
                        />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', gap: "20px", width: "100%" }}>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Culet Condition"
                            placeholder="Enter Culet Condition"
                            value={culetcondition}
                            onChange={(e) => setCuletCondition(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Laser incription"
                            placeholder="Enter Laser incription"
                            value={laserinscription}
                            onChange={(e) => setLaserIncription(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Table Percent"
                            placeholder="Enter Table Percent"
                            value={tablepercent}
                            onChange={(e) => setTablePercent(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Depth Percent"
                            placeholder="Enter Depth Percent"
                            value={depthpercent}
                            onChange={(e) => setDepthPercent(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Measurements"
                            placeholder="Enter Measurements"
                            value={measurements}
                            onChange={(e) => setMeasurements(e.target.value)}
                        />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', gap: "20px", width: "100%" }}>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Open"
                            placeholder="Enter Open"
                            value={open}
                            onChange={(e) => setOpen(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Girdlemin"
                            placeholder="Enter Girdlemin"
                            value={girdlemin}
                            onChange={(e) => setGirdlemin(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Note"
                            placeholder="Enter Note"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Gridle Condition"
                            placeholder="Enter Gridle Condition"
                            value={girdlecondition}
                            onChange={(e) => setGirdleCondition(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Intensity Longtitle"
                            placeholder="Enter Intensity Longtitle"
                            value={intensitylongtitle}
                            onChange={(e) => setIntensityLongtitle(e.target.value)}
                        />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', gap: "20px", width: "79.5%" }}>
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Pavilion Depth"
                            placeholder="Enter Pavilion Depth"
                            value={paviliondepth}
                            onChange={(e) => setPavilionDepth(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Gridle Percent"
                            placeholder="Enter Gridle Percent"
                            value={girdlepercent}
                            onChange={(e) => setGirdlePercent(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="White"
                            placeholder="Enter White"
                            value={white}
                            onChange={(e) => setWhite(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Pavilion Angle"
                            placeholder="Enter Pavilion Angle"
                            value={pavilionangle}
                            onChange={(e) => setPavilionAngle(e.target.value)}
                        />
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <Button
                            variant="contained"
                            color="info"
                            onClick={handleReset}
                            disabled={loading}
                        >
                            Reset
                        </Button>
                        <Box>
                            <LoadingButton
                                loading={loading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="contained"
                                color="success"
                                onClick={handleEvaluation}
                                disabled={saveButtonDisable()}
                                sx={{ mr: 1 }}
                            >
                                Save
                            </LoadingButton>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Close
                            </Button>
                        </Box>
                    </Box>
                </Modal.Footer>

            </Modal>
        </Box>
    )
}
